import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import DynamicFontSize from "../DynamicFontSize";
import DynamicSizeIcon from "../DynamicSizeIcon";
import { useGlobalData } from "@/contexts/GlobalData";
import Link from "next/link";
export interface SectionTitlePropsType extends GeneralPropsType {
  icon?: string;
  hiddenIcon?: boolean;
  onClickIcon?: (data?: any) => any;
  iconWidth?: number;
  iconLink?: string;
}
function SectionTitle({
  icon,
  children,
  hiddenIcon,
  className,
  iconWidth = 11,
  iconLink,
  onClickIcon
}: SectionTitlePropsType) {
  const {
    getIcon
  } = useGlobalData();
  return <DynamicFontSize fontSize={14} className={clsx("flex items-stretch justify-between", styles.container, styles.title, className)} data-sentry-element="DynamicFontSize" data-sentry-component="SectionTitle" data-sentry-source-file="index.tsx">
            <span>{children}</span>
            {!hiddenIcon && <>
                    {!iconLink && <div onClick={onClickIcon} className="flex-1 flex justify-end items-center !max-w-[50px]">
                            <DynamicSizeIcon width={iconWidth} icon={icon ?? getIcon("forward_primary")} />
                        </div>}
                    {!!iconLink && <Link href={iconLink} onClick={onClickIcon} className="flex-1 flex justify-end items-center !max-w-[50px]">
                            <DynamicSizeIcon width={iconWidth} icon={icon ?? getIcon("forward_primary")} />
                        </Link>}
                </>}
        </DynamicFontSize>;
}
export default SectionTitle;